import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  root: {
    padding: '1.72em 0 2em',
    opacity: 0.5,
  },
});

const NoResults = () => {
  const classes = useStyles();

  return (
    <Typography variant="h3" align="center" className={classes.root}>
      No Results
    </Typography>
  );
};

export default NoResults;
